/* eslint-disable @typescript-eslint/naming-convention */
import React, { useState } from 'react';

import type { PaymentVendors } from '@swf/cms';
import { CMSLink, CMSLinkedImage } from '@swf/cms';
import Translation from '@swf/components/Translation/Translation';
import Cross from '@swf/core/assets/icons/cross.svg';
import Tick from '@swf/core/assets/icons/tick.svg';

import { TXTCLI_Deposit, TXTCLI_Method, TXTCLI_Withdraw } from './CMSPaymentVendors.messages.json';
import styles from './CMSPaymentVendors.scss';

const CMSPaymentVendors: React.FC<PaymentVendors> = ({
  countries,
  start_at,
  payment_providers
}) => {
  const [selectedCountry, setSelectedCountry] = useState(
    countries.find((country) => country.code === start_at)?.code || countries[0].code
  );

  const vendors = payment_providers.filter(
    (provider) =>
      provider.deposit_country_codes.includes(selectedCountry.toLowerCase()) ||
      provider.withdraw_country_codes.includes(selectedCountry.toLowerCase())
  );

  return countries ? (
    <div className={styles.paymentVendorsSection}>
      <div className={styles.controlContainer}>
        <select
          className={styles.country}
          value={selectedCountry}
          onChange={(e) => setSelectedCountry(e.target.value)}
        >
          {countries.map((country) => (
            <option value={country.code} key={country.code}>
              {country.title}
            </option>
          ))}
        </select>
      </div>
      <div className={styles.tableWrapper}>
        <table className={styles.vendorTable}>
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th>
                <Translation {...TXTCLI_Method} />
              </th>
              <th>
                <Translation {...TXTCLI_Deposit} />
              </th>
              <th>
                <Translation {...TXTCLI_Withdraw} />
              </th>
            </tr>
          </thead>
          <tbody>
            {vendors &&
              vendors.map((item, index) => (
                <tr key={index}>
                  <td>
                    <CMSLinkedImage {...item.logo} />
                  </td>
                  <td>
                    <CMSLink title={item.title} url={item.logo.link.url} target="_self" />
                  </td>
                  <td>
                    {item.deposit_country_codes.includes(selectedCountry.toLowerCase()) ? (
                      <Tick className={styles.tickIcon} />
                    ) : (
                      <Cross className={styles.crossIcon} />
                    )}
                  </td>
                  <td>
                    {item.withdraw_country_codes.includes(selectedCountry.toLowerCase()) ? (
                      <Tick className={styles.tickIcon} />
                    ) : (
                      <Cross className={styles.crossIcon} />
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  ) : null;
};

export default CMSPaymentVendors;
